import { useEffect, useRef } from "react";
import { type FieldPath, useFormContext } from "react-hook-form";
import type { DATEVConfigRecord } from "../providers/datevProvider";

export function useDATEVValidationNavigation(fieldsByStep: string[][], onStepChange: (step: number) => void) {
  const { formState, getFieldState } = useFormContext<DATEVConfigRecord>();
  const handledSubmitCount = useRef(0);
  const { submitCount, errors } = formState;
  useEffect(() => {
    if (submitCount === handledSubmitCount.current) return;
    handledSubmitCount.current = submitCount;
    const invalidStep = fieldsByStep.findIndex((fields) =>
      fields.some((field) => getFieldState(field as FieldPath<DATEVConfigRecord>).error),
    );
    if (invalidStep >= 0) {
      onStepChange(invalidStep);
      showErrorToast("Bitte korrigiere die markierten Felder, bevor du die neue Version speicherst.");
    }
  }, [submitCount, errors, fieldsByStep, getFieldState, onStepChange]);
}
